import React, { useEffect, useState , useRef} from "react";
import "odometer/themes/odometer-theme-default.css"; 
import Odometer from "react-odometerjs";
import "./Facts.css";
import gsap from 'gsap'
import {useGSAP} from '@gsap/react'

const Facts = () => {
  const [experience, setExperience] = useState(0);
  const [projects, setProjects] = useState(0);
  

  useEffect(() => {
    const t = setTimeout(() => {
      setExperience(2);
      setProjects(10);
    }, 800); 
    return () => clearTimeout(t);
  }, []);
  const container = useRef(null)
  gsap.registerPlugin(useGSAP)
  useGSAP(()=>{
    const timeline = gsap.timeline();
    timeline
    .from(".fact__item",{
      delay:1.5,
      x:-100,
      stagger:.5,
      opacity:0,
    })
  })
  return (
    <div className="fact__container" ref={container}>
      <div className="fact__item">
        <div className="count__container">
          <Odometer value={experience} format="d" />
          <span className="indicator">+</span>
        </div>
        <p className="name">Years Of Experience</p>
      </div>
      <div className="fact__item">
        <div className="count__container">
          <Odometer value={projects} format="d" />
          <span className="indicator">+</span>
        </div>
        <p className="name">Completed Projects</p>
      </div>
    </div>
  );
};

export default Facts;
